import { ServiceCallType } from './definitions';
import { ServiceCallRunner } from './service-call-runner';

export abstract class AbstractService {
  resources!: { [key: string]: ServiceCallType };

  constructor(public serviceCallRunner: ServiceCallRunner) {}
}
